import { IconButton, styled, Typography } from '@mui/material';

export const FromContainer = styled('div')`
  width: 671px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid #ddd;
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 16px;
  margin-right: 36px;

  @media (max-width: 1023px) {
    width: 100%;
    padding: 16px 8px;
    margin-right: 0px;
  }
`;

export const LabelTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '24px',
  color: theme.palette.primary.p080,
  marginBottom: '16px',
  marginLeft: '10px',
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '8px',
  },
}));

export const RichEditorW = styled('div')`
  @media (max-width: 1023px) {
    margin-bottom: 8px;
  }
`;

export const CloseButtonW = styled(IconButton)`
  margin-left: auto;
  position: fixed;
  top: 79px;
  right: 88px;
`;

export const FormAndPreviewW = styled('div')`
  display: flex;
  align-items: flex-start;
`;

export const PreviewTitle = styled(Typography)`
  font-size: 14px;
  line-height: 10px;
  color: ${({ theme }) => theme.palette.primary.p030};
  position: absolute;
  top: -32px;
`;
